import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}

import { computed, ref, watch } from "vue";
import { getRandomId } from "@/mixins/global.mixin";
import { TranslateResult } from "vue-i18n";
import { kebabCase } from "lodash";

export interface Props {
  value: string | boolean | number;
  values?: {
    select: boolean;
    unselect: boolean;
  };
  label?: string | TranslateResult;
  size?: string;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputCheckbox',
  props: {
    value: { type: [String, Boolean, Number], default: true },
    values: { default: () => ({
    select: true,
    unselect: false,
  }) },
    label: { default: "" },
    size: { default: "md" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const key = ref(getRandomId());

const wrapperClasses = computed(() => {
  return { disabled: props.disabled };
});

const selected = computed({
  get() {
    const { select } = props.values;

    return props.value === select;
  },
  set(value) {
    const { select, unselect } = props.values;
    const result = value ? select : unselect;

    emit("input", result);
  },
});

const checkboxValue = computed({
  get() {
    return selected.value;
  },
  set() {
    // disabled default checkbox value
  },
});

const checkboxSizeClass = computed(() => {
  return {
    "size-sm": props.size === "sm",
    "size-md": props.size === "md",
    "size-lg": props.size === "lg",
  };
});

watch(
  () => selected.value,
  () => {
    key.value = getRandomId();
  },
  { immediate: true }
);

const onClickCheckboxWrapper = () => {
  if (!props.disabled) {
    selected.value = !selected.value;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_t_checkbox = _resolveComponent("t-checkbox")!
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([wrapperClasses.value, "input-wrapper"])
  }, [
    (_openBlock(), _createBlock(_component_t_checkbox, {
      key: key.value,
      ref: "checkbox",
      modelValue: checkboxValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxValue).value = $event)),
      "data-cy": `checkbox-${_unref(kebabCase)(_ctx.label)}`,
      class: _normalizeClass(["checkbox", checkboxSizeClass.value]),
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "data-cy", "class", "disabled"])),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_touch, onClickCheckboxWrapper]
  ])
}
}

})